module.exports = __webpack_public_path__ + "static/owen-51a96319bf700e7f40adf942a29c18d7.jpg";